type Props = {
    drillStream: string | null
    aggregateCount: number
    loading: boolean
    errored: boolean
    contextLabel: string | null
  }
  
  export default function DeepDiveHeader({
    drillStream,
    aggregateCount,
    loading,
    errored,
    contextLabel,
  }: Props) {
    return (
      <div className="panel-head">
        <span className="panel-title">
          {drillStream
            ? `Deep dive · ${drillStream}`
            : `Analysis · aggregate (${aggregateCount})`}
        </span>
        {loading && (
          <span style={{ marginLeft: 10, fontSize: 10, color: 'var(--t-2)' }}>Loading…</span>
        )}
        {errored && (
          <span style={{ marginLeft: 10, fontSize: 10, color: 'var(--crit)' }}>API error</span>
        )}
        {contextLabel && (
          <span style={{ fontSize: 10, color: 'var(--t-2)', marginLeft: 'auto' }}>
            {contextLabel}
          </span>
        )}
      </div>
    )
  }